module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_45"
    }
  }, [_c('span', [_vm._v("35")])]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e492245"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c4_r1#d6e8",
      "id": "d7e8"
    }
  }, [_vm._v("5 "), _c('br'), _c('br'), _c('i', [_vm._v("Humor of the Self ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph",
    attrs: {
      "id": "d7e493045"
    }
  }, [_c('span', [_c('i', [_vm._v("What is funny about us is precisely that we take ourselves too seriously.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extbd",
    attrs: {
      "id": "d7e493545"
    }
  }, [_c('span', [_vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EINHOLD ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IEBUHR ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e494045"
    }
  }, [_c('span', [_vm._v("Self-effacing humor was a bright birthmark of both Chesterton and Lewis. Chesterton could not resist caricaturing himself as a figure of fun. He made jokes about his gigantic size, and in so doing reduced the height of his platform and made himself an equal with his audience. When he began a speech to the Union at Oxford, for example, he announced, “I am not a cat burglar”—and he had his audience by the whiskers. Once, when stuck in the door of a car, Chesterton compared himself to the old Irishwoman who, when asked, “Why don’t you get out sideways?” replied, “I have no sideways.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d79",
      "id": "a79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e497445"
    }
  }, [_c('span', [_vm._v("Edward Macdonald recalled one special anecdote Chesterton used about his image: “When Thomas Derrick drew his famous cartoon of G.K.C. milking a cow he hesitated to give it to me for fear that G.K.C. would be offended.” Macdonald wanted to print it but first telephoned Chesterton and requested his permission, adding that he may not like it. “I would rather it were not printed,” he replied. “I never like the idea of my name being used in the title of the paper and don’t want well-intentioned but embarrassing personalities. Of course, if it were highly satirical, insulting, and otherwise unflattering I’d gladly have it on the front-page.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d80",
      "id": "a80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e501145"
    }
  }, [_c('span', [_vm._v("Lewis saw himself in this sort of self-effacing comic mold as well. As a schoolboy he described himself as clumsy and unfit for games and parties. He abhorred being stuffed into his Eton suit and stiff shirt and made to endure the torment of neighborhood dances, suffering the “aching feet and burning head, and the mere weariness of being kept up so many hours after one’s usual bedtime.” For such persecution, “I positively felt that I could have torn my hostess limb from limb. Why should she thus pester me? I have never done her any harm, never asked her to a party.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d81",
      "id": "a81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" What aggravated such social tortures was that Lewis didn’t mix well with children his own age. Reading much more than his peers, he had “developed a vocabulary which must (I now see) have sounded very funny from the lips of a chubby urchin in an Eton jacket.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d82",
      "id": "a82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_46"
    }
  }, [_c('span', [_vm._v("36")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e506446"
    }
  }, [_c('span', [_vm._v("Lewis portrayed with precision the embarrassing humor we all face in ill-at-ease situations when he described his young hero Shasta using the reins on an ordinary horse. Shasta “looked very carefully out of the corners of his eyes to see what the others were doing (as some of us have done at parties when we weren’t quite sure which knife or fork we were meant to use).”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d83",
      "id": "a83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Lewis may have been confessing his lack of social poise as well in an aside about Prince Rabadash. The prince had gotten stuck on a castle wall, and “his chain-shirt was somehow hitched up so that it was horribly tight under the arms and came half way over his face. In fact he looked just as a man looks if you catch him in the very act of getting into a stiff shirt that is a little too small for him.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d84",
      "id": "a84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e511246"
    }
  }, [_c('span', [_vm._v("Lewis discovered comic irony, a “curious mixture of justice and injustice,” in being blamed for real faults but at the wrong time. When he used “long words,” adults saw him as a conceited boy who was showing off. But these were the only words he knew; he simply hadn’t yet been acquainted with schoolboy slang. “And there were not lacking adults who would egg me on with feigned interest and feigned seriousness—on and on till the moment at which I suddenly knew I was being laughed at.” Lewis’s defense was to affect a sillier demeanor, to develop a feigned party manner of “a giggling and gurgling imitation of the vapidest grown-up chatter.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d85",
      "id": "a85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e515246"
    }
  }, [_c('span', [_vm._v("The same ironic mixture occurred when he was disliked at Wyvern College. He was not only the kind of new boy who skipped clubs, but")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e516046"
    }
  }, [_c('span', [_vm._v("I was big for my age, a great lout of a boy, and that sets one’s seniors against one. I was also useless at games. Worst of all, there was my face. I am the kind of person who gets told, “And take that look off your face too.” Notice, once more, the mingled justice and injustice of our lives. No doubt in conceit or ill temper I have often intended to look insolent or truculent; but on those occasions people don’t appear to notice it. On the other hand, the moments at which I was told to “take that look off” were usually those when I intended to be most abject."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d86",
      "id": "a86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_47"
    }
  }, [_c('span', [_vm._v("37")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e519947"
    }
  }, [_c('span', [_vm._v("His own physical appearance provided Lewis with raw comic material. He described wrinkles as the “honorable insignia of long service in this warfare.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d87",
      "id": "a87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" And his photograph in "), _c('i', [_vm._v("Time ")]), _vm._v("magazine was “a useful mortification; good as a hair shirt. (What an exaggeration! as if one wouldn’t rather look like the Ugly Duchess than wear even ordinary tickly underclothing for half a day!)”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d88",
      "id": "a88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e523347"
    }
  }, [_c('span', [_vm._v("The balding Lewis was glad to “have outgrown the muscular weakness of children; but we envy those who retain its energy, its well-thatched scalp.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d89",
      "id": "a89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" To cover his little-thatched scalp, Lewis wore a hat that became quite famous. Warnie Lewis told one memorable anecdote about his brother’s covering:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e525847"
    }
  }, [_c('span', [_vm._v("Jack’s clothes were a matter of complete indifference to him: he had an extraordinary knack of making a new suit look shabby the second time he wore it. One of his garments has passed into legend. It is said that Jack once took a guest for an early morning walk on the Magdalen College grounds, in Oxford, after a very wet night. Presently the guest brought his attention to a curious lump of cloth hanging on a bush. “That looks like my hat,” said Jack; then, joyfully, “It is my hat.” And, clapping the sodden mass on his head, he continued his walk."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d90",
      "id": "a90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e529747"
    }
  }, [_c('span', [_vm._v("Lewis compared having a body to having an old automobile—“When all sorts of apparently different things keep going wrong, but what they add up to is the plain fact that the machine is wearing out! Well, it was not meant to last forever. Still, I have a kindly feeling for the old raddle trap.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d91",
      "id": "a91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_48"
    }
  }, [_c('span', [_vm._v("38")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e532348"
    }
  }, [_c('span', [_vm._v("At Lewis grew older, he joked about his health and his imminent reception in heaven. “What on earth is the trouble about there being a rumor of my death? There’s nothing discreditable in dying: I’ve known the most respectable people to do it.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d92",
      "id": "a92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e534148"
    }
  }, [_c('span', [_vm._v("When this old life is finally over, Lewis wondered, how would God deal with each person individually? Perhaps by consulting reference books? “Gabriel, bring me Mr. Lewis’s file.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d93",
      "id": "a93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e535648"
    }
  }, [_c('span', [_vm._v("Chesterton received rebukes for similar whimsies. One indignant gentleman accused him of flippancy in degrading spiritualism.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e536648"
    }
  }, [_c('span', [_vm._v("I thought I was defending Spiritualism; but I am rather used to being accused of mocking the thing I set out to justify. My fate in most controversies is rather pathetic. It is an almost invariable rule that the man with whom I don’t agree thinks I am making a fool of myself, and the man with whom I do agree thinks I am making a fool of him."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d94",
      "id": "a94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e539248"
    }
  }, [_c('span', [_vm._v("Being laughed at did not seem to bother either Chesterton or Lewis very much, particularly when the mockery was loving. Lewis’s wife teased her husband merrily, and he learned “not to talk rot to her unless I did it for the sheer pleasure . . . of being exposed and laughed at. I was never less silly than as H’s lover.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d95",
      "id": "a95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e541348"
    }
  }, [_c('span', [_vm._v("Chesterton unexpectedly came upon a fiasco in his spiritual autobiography: that, in trying to concoct a new religion and a heresy of his own, he discovered that it was Christian orthodoxy. In his defense of Christianity, Chesterton lamented that the book could not avoid being egotistical, but then again, it could not also avoid being dull:")])]), _vm._v(" "), _c('p', {
    staticClass: "exti",
    attrs: {
      "id": "d7e543648"
    }
  }, [_c('span', [_vm._v("Dulness will, however, free me from the charge which I most lament; the charge of being flippant. Mere light sophistry is the thing that I happen to despise most of all things, and it is perhaps a wholesome fact that this is the thing of which I am generally accused. . . . I never in my life said anything merely because I thought it funny; though of course, I have had ordinary human vainglory, and may have thought it funny because I said it. . . . I offer this book with the heartiest sentiments to all the jolly people who hate what I write, and regard it (very justly, for all I know) as a piece of poor clowning or a single tiresome joke. . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_49"
    }
  }, [_c('span', [_vm._v("39")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e547649"
    }
  }, [_c('span', [_vm._v("For if this book is a joke it is a joke against me. I am the man who with the utmost daring discovered what had been discovered before. If there is one element of farce in what follows, the farce is at my own expense . . . no reader can accuse me here of trying to make a fool of him: I am the fool of this story, and no rebel shall hurl me from my throne."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d96",
      "id": "a96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e550149"
    }
  }, [_c('span', [_vm._v("Chesterton laughed robustly at jokes at his own expense, often howling with joy. His voice, however, was unequal to his stature. Cosmo Hamilton described his high laughter as “peahen-like quarks of joy.” Chesterton himself referred to the incongruity of his voice and size as “the mouse that came forth from the mountain.” Yet his girth did not outsize his boisterous mirth, which Hamilton celebrated as “a sight and sound for the gods.” Chesterton laughed at “his own jokes because they came to him as part of the joint findings of the quest, something he had seen and collected and brought for the pot.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d97",
      "id": "a97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" And Lewis dipped a large soup spoon into his pot.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e554249"
    }
  }, [_c('span', [_vm._v("Humans might easily be defined as self-reflexive animals. One cannot help thinking and speaking of oneself (and even feeling oneself to be, for certain purposes as two people, one of whom can act upon and observe the other). Thus one pities, loves, admires, hates, despises, rebukes, comforts, examines, and masters (or is mastered by) “oneself.” One is privy to one’s own acts, as one’s own conscience or accomplice. Armed with such a perspective, one is audience to one’s own humanity and folly—a witness to and against oneself.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_50"
    }
  }, [_c('span', [_vm._v("40")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e557450"
    }
  }, [_c('span', [_vm._v("One of Lewis’s dominant comic techniques was such self-reflexivity. It is a model of what Steve Seidman calls “comedian comedy,” in which the humorist steps outside the joke to comment on it, or outside a story, a sermon, or an argument to provide a comic perspective on his or her own role. It is the comic aside that is so robust in certain film comedians. In the film "), _c('i', [_vm._v("Horse Feathers")]), _vm._v(", Groucho Marx sees that a musical interlude is about to occur, steps forward, and says to the camera: “I’ve got to stay here. But there’s no reason why you folks shouldn’t go into the lobby until this thing blows over.” Likewise, in "), _c('i', [_vm._v("The Road to Bali")]), _vm._v(", Bob Hope pauses, just before Bing Crosby starts to sing, and warns: “He’s going to sing, folks. Now’s the time to go outside and get the popcorn.” Self-references are bracketed in these films even as they take us out of the filmic universe. Like a comic Greek chorus, the comedian talks directly to us, winks at us, and mutters "), _c('i', [_vm._v("sotto voce")]), _vm._v(", a la Woody Allen or Bugs Bunny, for our benefit. This breaks the illusion of a separate world, and a new immediacy and intimacy are created between the comic communicator and the audience.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e564650"
    }
  }, [_c('span', [_vm._v("Because Lewis wrote directly to his audience, he regularly used the bracketed aside to establish a humorous and often more personal relationship with his readers. He often broke out of his fiction, apologetics, or scholarly treatise to breathe in the personal, much like a dolphin irresistibly breaking the surface of the sea to breathe and squeal. Lewis used such opportunities to sneak in a comic avuncular aside, much the way E. Nesbit did in her children’s stories. In "), _c('i', [_vm._v("Five Children and It")]), _vm._v(", Nesbit steps out of her story to share the unknown reason why so many children who live in towns are naughty. And Lewis the storyteller slips out of his author’s cap as well to comment on the action: “Ten to one you have never seen a giant with his face beaming.” “Other creatures whom I won’t describe because if I did the grown-ups would probably not let you read this book.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d98",
      "id": "a98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" He even poked fun at his own literary invention. Discussing Mr. Beaver, he playfully added that “he now had a sort of modest expression on his face—the sort of look people have when you are visiting a garden they’ve made or reading a story they’ve written.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d99",
      "id": "a99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" With a modest expression on his face, Lewis must also have winked.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_51"
    }
  }, [_c('span', [_vm._v("41")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e572751"
    }
  }, [_c('span', [_vm._v("Self-reflexive humor occurs subtly in Lewis’s works. He refers to a man “in our time who wrote what he intended to be a general apologetic allegory for ‘all who profess and call themselves Christians,’ and was surprised to find it both praised and blamed as a defense of Rome.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d100",
      "id": "a100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Lewis, Screwtape’s stepfather, found it difficult to be merely a don in his writing output. Yet he wrote indirectly of his own low reputation at Oxford when showing how Tyndale")])]), _vm._v(" "), _c('p', {
    staticClass: "exti",
    attrs: {
      "id": "d7e575651"
    }
  }, [_c('span', [_vm._v("repeatedly twits More with being a “poet”: but everyone knew that poets were feigners and under the rules that then governed controversy the jibe was almost inevitable. Even now a writer who has ventured on any imaginative work is likely to have the fact used against him when he turns to criticism or theology."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d101",
      "id": "a101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e577751"
    }
  }, [_c('span', [_vm._v("Lewis did twit his fellows back at Oxford once he moved to Cambridge. In his inaugural address, he complained that older and erroneous pictures of the Middle Ages have “survived among weaker brethren, if not [let us hope] at Cambridge, yet certainly in that Western darkness from which you have . . . bidden me emerge.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d102",
      "id": "a102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e580351"
    }
  }, [_c('span', [_vm._v("His vocation as a scholar prompted much self-mocking. In writing of Martianus, who stored in his mind the knickknacks of others’ philosophies and religions, Lewis confessed, “I have heard the scholar defined as one who has a propensity to collect useless information, [who] gloats and catalogues, but never dusts them for even their dust is precious in his eyes.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d103",
      "id": "a103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Lewis did not hide the fact that he was sufficiently of the “author’s kidney to enjoy the faint smell of secular dust.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d104",
      "id": "a104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Yet he made light of the devoted habit of the professor’s reading dry-as-dust books: “Few men at any period can have obeyed Martin’s light-hearted command to ‘rede ouer Doctor Bridges’; I have skipped some pages myself.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d105",
      "id": "a105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e585551"
    }
  }, [_c('span', [_vm._v("Lewis laughed even at the influence that Dryden had on him, evidenced in his going through the “Essay of Dramatick Poesie” and altering every sentence that ended with a preposition. Lewis detested this “frenchified schoolroom superstition,” which often plucked at his elbow, knowing this curious and unwelcome grammatical taboo would not have happened without Dryden. He wrote, with a twinkle in his eye (and a preposition dangling): “It is so alien from the language that it has never penetrated into the conversation of even the worst prigs, and serves no purpose but to increase those little bunches of unemphatic monosyllables that English was already prone to.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d106",
      "id": "a106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_52"
    }
  }, [_c('span', [_vm._v("42")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e589752"
    }
  }, [_c('span', [_vm._v("Lewis frequently inserted inside jokes into his essays. In one, he spoke of two young boys who stole a cigar and smoked it before its time: “And may I add the important moral of the story? One of these boys has been permanently punished by a life-long inability to appreciate cigars.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d107",
      "id": "a107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Lewis played gamely also with his heritage. It is true, he wrote, that Spenser “hated the Irish and they him: but, as an Irishman myself, I take leave to doubt whether that is a very un-Irish trait. (‘The Irish, sir,’ said Dr. Johnson, ‘are an honest people. They never speak well of one another’).”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d108",
      "id": "a108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e593652"
    }
  }, [_c('span', [_vm._v("In "), _c('i', [_vm._v("That Hideous Strength")]), _vm._v(", Lewis created a fictional character, Dr. Dimble, who as a college don was a not-so-dim reflection of the author. His delight in Arthurian legend and gardening and his distrust of psychoanalysis paralleled Lewis’s. Even more revealing was an attitude toward mediocre students—as, for example, when Dr. Dimble looked out of a window: “ ‘There is my dullest pupil just ringing the bell,’ he said. ‘I must go to the study, and listen to an essay on Swift beginning, “Swift was born.” Must try to keep my mind on it, too, which won’t be easy.’ ”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d109",
      "id": "a109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e597452"
    }
  }, [_c('span', [_vm._v("Lewis bemoaned the answers he received from many students on questions such as, “contrast the characters Uriah Heep and Mr. Micawber.” One student would write: “U. H. is the finished type of a rogue; Mr. M. on the other hand is the portrait of a happy-go-lucky debtor.” The next paper would simply reverse the answer. There was “too much maddening jargon on ‘the finished portrait of a rogue.’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d110",
      "id": "a110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_53"
    }
  }, [_c('span', [_vm._v("43")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e600453"
    }
  }, [_c('span', [_vm._v("John Lawlor remembered Lewis as Oxford tutor and scholar, and recalled that upon first encountering pupils Lewis would ask: “What have you been reading?”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d111",
      "id": "a111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Lewis reconstructed one initial meeting in a breezy, jovial letter to his father:"), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e602553"
    }
  }, [_c('span', [_c('b', [_vm._v("SELF: ")]), _vm._v("“Well, S., what Greek authors have you been reading?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e603253"
    }
  }, [_c('span', [_c('b', [_vm._v("S: ")]), _vm._v("(cheerfully) “I can never remember. Try a few names and I’ll see if I get on to any.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e604453"
    }
  }, [_c('span', [_c('b', [_vm._v("SELF: ")]), _vm._v("“Any Sophocles?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e605353"
    }
  }, [_c('span', [_c('b', [_vm._v("S: ")]), _vm._v("“Oh yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e606253"
    }
  }, [_c('span', [_c('b', [_vm._v("SELF: ")]), _vm._v("“What plays of his have you read?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e607253"
    }
  }, [_c('span', [_c('b', [_vm._v("S: ")]), _vm._v("(after a pause) “Well—the Alcestis.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e608153"
    }
  }, [_c('span', [_c('b', [_vm._v("SELF: ")]), _vm._v("(apologetically) “But isn’t that by Euripedes?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e609053"
    }
  }, [_c('span', [_c('b', [_vm._v("S: ")]), _vm._v("(with the genial surprise of a man who finds £1 where he thought there was only a 10/-note) “Really. Is it now? Then by Jove I have read some Euripedes.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d112",
      "id": "a112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e610953"
    }
  }, [_c('span', [_vm._v("Most students were not so cheery and blissfully ignorant. Still, even in their cowering or awe they found good humor in their relations with Lewis. Adam Fox recalled that when one student was questioned about the matter of a date, he “referred to his own manuscript and said with some assurance, ‘Well, it says so here.’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d113",
      "id": "a113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Another interrupted Lewis during his prayers and Lewis told him he couldn’t enter the room but should instead “kneel down and pray for me.” The student obeyed. Another apologetically asked if he could turn in his unfinished essay the next day. Lewis responded: “Oh, that’s quite all right, my dear boy, quite all right, but you must bring me a suitable bribe.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d114",
      "id": "a114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" The next day Lewis received the finished essay and a bottle of whiskey.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e615553"
    }
  }, [_c('span', [_vm._v("Tutoring girls sent shivers up Lewis’s bachelor spine. One colleague confided that Lewis had been worried by a woman who repeatedly approached him at the end of his lectures. She eventually proposed, afterward pretending it was a joke, but, his friend said, “It wasn’t. And she wasn’t the only one either. A man who lectures to women takes his life in his hands.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d115",
      "id": "a115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Lewis feared this prospect of the Abelard and Heloise relation. Engagement was “that fatal tomb of all lively and interesting men.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d116",
      "id": "a116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" His concern escalated particularly when he was called upon to lecture at a women’s college. He wrote:")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_54"
    }
  }, [_c('span', [_vm._v("44")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e620354"
    }
  }, [_c('span', [_vm._v("However I am not engaged to be married yet, and there are always seven of them there together, and the pretty ones are stupid and the interesting ones are ugly, so it is all right. I say this because as a general rule women marry their tutors. I suppose if a girl is determined to marry and has a man alone once a week to whom she can play the rapt disciple (most fatal of all poses to male vanity) her task is done."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d117",
      "id": "a117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e622854"
    }
  }, [_c('span', [_vm._v("George Bailey compared the Lewis of the university to a “school book description of Friar Tuck,” with a pronouncedly hearty manner and a booming voice “given to what someone once called ‘rhetorical guffawing’ (‘Ho, ho, ho, so you think Milton was ascetic, do you? Ho, ho! You are quite wrong there.’).”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d118",
      "id": "a118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e624954"
    }
  }, [_c('span', [_vm._v("His lecture style at the rostrum was disciplined, deceptively easy, and deadpan. Bailey recalled one instance in which Lewis, who never “threw away a line,” displayed his discrete humor. In a prolegomenon, Lewis said with dry, casual asides: “Reason can see truth in sleep with three kinds of clarity: . . . in the oracle kind (oraculum) some venerable person (an ancestor, wise-man, parent, or "), _c('i', [_vm._v("even ")]), _vm._v("a tutor) appears and announces truth otherwise unknown.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d119",
      "id": "a119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" He garnered good laughs in his lectures, as his lines were perfectly “timed with all an actor’s skills.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d120",
      "id": "a120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Upon lecturing an audience of women who were expected to wear academic gowns but hadn’t, he began with mock modesty: “Oh! I must apologize for wearing a gown!” At the next meeting, gowns were in fashion again."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d121",
      "id": "a121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e630954"
    }
  }, [_c('span', [_vm._v("The habitat of Oxford encouraged the cult of wit among its dons. Witty, casual remarks were designed, even “elaborately contrived,” as ripostes or rejoinders. What was called for, said Bailey, was “dry, desultory, almost surreptitious humor, the nonchalant riposte . . . and best of all—whimsy.” Such was Lewis’s gift. Once knocking his pipe ashes out of a window overlooking a garden, Lewis was abruptly interrupted by a lively stranger who dashed into his room, shouting: “Do you realize that you almost blinded my baby?” “No,” said Lewis, “I didn’t even know you were married”—a rim-shot line worthy of W. C. Fields."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d122",
      "id": "a122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_55"
    }
  }, [_c('span', [_vm._v("45")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e634955"
    }
  }, [_c('span', [_vm._v("Owen Barfield testified to the predominance of Lewis’s comic spirit in conversation. His was a friendly playfulness, like that of Charles Lamb. (Lamb once responded to the poet Coleridge, when the latter asked if he’d ever heard him preach a sermon: “My dear fellow, I never heard you do anything else!”) Lewis’s humor was a loud hint of an intellectual intimacy given to his close friends. Barfield observed that “a good deal could be said about the absolute necessity of humor, as an available ingredient, to any really deep thinker, as distinct from . . . a merely solemn one.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d123",
      "id": "a123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e638355"
    }
  }, [_c('span', [_vm._v("Indeed, humor can be useful as a form of “packaging,” of typing up a whole argument and its parts into a memorably comic complex—like Lewis’s discussion of Bluspels and Flalanspheres. His longtime friend Barfield faithfully stressed Lewis’s “irrepressible bent for comedy, simply because without that emphasis one would miss altogether the typical flavor of his company.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d124",
      "id": "a124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" This humor was not buffoonery, flippancy, or even “professional” jesting, but, rather, fun—hearty, healthy, good-natured fun, evident in the “almost habitual breeze of irony at his own, and of sarcasm at his friends’ expense.” Yet his humor was never mean, bitter, or bitingly sarcastic. In a letter to Barfield, Lewis teased that the villainous characters in "), _c('i', [_vm._v("That Hideous Strength ")]), _vm._v("(Wither, Frost, Feverstone, even Fairy Hardcastle) were all portraits of Barfield. If he didn’t mention this, he wrote, “that may have been because it isn’t true. By gum, though, wait until I write another story.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d125",
      "id": "a125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e644255"
    }
  }, [_c('span', [_vm._v("Lewis followed and echoed Aristotle’s exhortation to his pupils “to play in order to become generous or noble.” Above all, one should play! For Lewis, the Germanic idea of “humor” contained too much gravity and thus offered only a pretense to play. A weighty concept like "), _c('i', [_vm._v("Schadenfreude")]), _vm._v(", delighting in the misfortunes of others, could almost crush laughter. Yet if humor must not be too heavy, it also must not be too flippant. Although Lewis")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_56"
    }
  }, [_c('span', [_vm._v("46")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e647256"
    }
  }, [_c('span', [_vm._v("would readily make fun of the great men of the past and exhibit them in a nonsensical light, he would only do so with those who knew and revered them as he did himself. A joke at the expense of Shelley or Goethe is a joke precisely because they were great men. “In the mouth, or in the presence, of those who have never experienced that greatness, it is merely boorishness.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d126",
      "id": "a126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e649956"
    }
  }, [_c('span', [_vm._v("Lewis used a tangy, dry wit to gently puncture those who presumptuously assumed an air of knowledge. He observed, for example, that “every week a clever undergraduate, every quarter a dull American don, discovers for the first time what some Shakespearean play really meant.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d127",
      "id": "a127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" He found absurdity even in the tomes he dusted in the library. He thought one reference work particularly intriguing: "), _c('i', [_vm._v("Every Man His Own Lawyer")]), _vm._v("—"), _c('i', [_vm._v("Illustrated")]), _vm._v(". Lewis looked in vain, however,")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e653656"
    }
  }, [_c('span', [_vm._v("for a portrait of a tort or a south aspect of Habeas Corpus—the pictures consisting entirely of courthouses and famous judges. Can you imagine anything more infuriating than, on turning to such a book to try to extricate yourself from an Income Tax muddle or an injudicious betrothal (and for what other purpose would you ever open it?) to be met with the bland features of Lord Darling?"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d128",
      "id": "a128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e656156"
    }
  }, [_c('span', [_vm._v("Not surprisingly, Lewis found the rites and rituals of the academic community funny. He perceived his formal admission to Magdalen College as a ceremonial event of unacknowledged comedy. Ushered into a grand room, he saw a red cushion laid before the feet of the college president. “I realized with some displeasure that this was going to be a kneeling affair.” After several minutes of an incomprehensible Latin address and his own uncertain responses, Lewis was raised up by the hand as the president pronounced, “I wish you joy.” Lewis wrote: “It sounds well enough on paper but it was hardly impressive in fact; and I tripped over my gown in rising.” The ordeal included the blessing from all the members, and the multiple repetitions of “I wish you joy” sounded odd: “English people have not the talent for graceful ceremonial. They go through it lumpishly and with a certain mixture of defiance and embarrassment, as if everyone felt he was being rather silly, and was at the same time ready to shoot down anyone who said so.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d129",
      "id": "a129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_57"
    }
  }, [_c('span', [_vm._v("47")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e659457"
    }
  }, [_c('span', [_vm._v("Lewis revealed a similar attitude toward the college administration:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e662757"
    }
  }, [_c('span', [_vm._v("Yes we have the word “dither” and the thing too. And our offices are in a dither too. This is so common that I suspect there must be something in the very structure of a modern office which creates Dither. Otherwise why does our “College Office” find full time work for a crowd of people in doing what the president of the College, 100 years ago, did in his spare time without a secretary and without a typewriter? (The more noise, heat, and smell a machine produces the more power is being wasted!)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d130",
      "id": "a130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e665857"
    }
  }, [_c('span', [_vm._v("Lewis satirized in his fiction the college office and its members and meetings. “Fellows of colleges,” he wrote, perhaps partly as confession, “do not always find money matters easy to understand: if they did, they would probably not have been the sort of men who became Fellows of colleges.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d131",
      "id": "a131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e667957"
    }
  }, [_c('span', [_vm._v("Lewis’s fiction also sketched outlines of his own professorial quirks. He knew his students found him amusing and eccentric, as all Oxford dons were supposed to be. A trace of this role found its way into "), _c('i', [_vm._v("The Last Battle")]), _vm._v(". Professor Digory Kirke acts the role of the quintessential professor when he instructs the children on the end of the old Narnia. He compares the old country to a shadow or a dream,")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e670457"
    }
  }, [_c('span', [_vm._v("but when he added under his breath “It’s all in Plato, all in Plato: bless me, what "), _c('i', [_vm._v("do ")]), _vm._v("they teach them at these schools!” the older ones laughed. It was so exactly like the sort of thing they had heard him say long ago in that other world where his beard was grey instead of golden. He knew why they were laughing and joined in the laugh himself."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d132",
      "id": "a132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_58"
    }
  }, [_c('span', [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e673958"
    }
  }, [_c('span', [_vm._v("Self-effacing humor was a common rhetorical device Lewis used in addressing his audiences. He once began an address to theological students: “The proper study of shepherds is sheep, not (save accidentally) other shepherds. And woe to you if you evangelize. I am not trying to teach my grandmother. I am a sheep, telling shepherds what only a sheep can tell them. And now I start my bleating.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d133",
      "id": "a133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Appearing before a Shakespearean audience, Lewis modestly indicated he felt “rather like a child brought in at dessert to recite his piece before the grown-ups.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d134",
      "id": "a134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" So he decided to bestow all his childishness upon them.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e678058"
    }
  }, [_c('span', [_vm._v("Lewis saw his own spiritual responsibilities with more honesty and humor than do most of us. In a letter to an American child, Laurence Krieg, whose mother worried that her son was worshiping Aslan more than Christ, Lewis composed a prayer for the boy. It ended with a postscript: “And if Mr. Lewis has worried any other children by his books or done them any harm, then please forgive him and help him never to do it again.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d135",
      "id": "a135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" Writing on the call to holiness in Thomas à Kempis’s "), _c('i', [_vm._v("Imitation of Christ")]), _vm._v(", he found it, to an almost comic degree, “not addressed to my condition.” When Kempis warned against “chatting in the kitchen when you ought to be in your cell,” Lewis confessed that “our temptation is to be in our studies when we ought to be chatting in the kitchen. (Perhaps if our studies were as cold as those cells it would be different.)”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d136",
      "id": "a136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e683658"
    }
  }, [_c('span', [_vm._v("Lewis faithfully reminded himself that we must learn to love those we don’t naturally like. Even pagans knew “that any beggar at your doorstep might be a god in disguise: and the parable of the sheep and the goats is Our Lord’s comment.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d137",
      "id": "a137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" He acknowledged that “it’s so much easier to pray for a bore than to go and see him.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d138",
      "id": "a138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" And both Lewis and his brother, Warnie, saw the wisdom in the New Testament’s exhortation to “visit the widows, not to let them visit us.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d139",
      "id": "a139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_59"
    }
  }, [_c('span', [_vm._v("49")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e687759"
    }
  }, [_c('span', [_vm._v("Chesterton in the same spirit quipped: “The Bible tells us to love our neighbors, and also to love our enemies; probably because they are generally the same people.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d140",
      "id": "a140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" This comic perspective equipped him and his godson of humor, Lewis, to view the spirit and the flesh with the same sense of balance. Their laughter liberated them from the prisons of both their times and their selves. They were given a vantage point from which to see and understand more clearly the folly of humanity, yet a folly divinely overseen and repaired.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6ede876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lind_9781595554796_epub_c12_r1.vue
// module id = 90
// module chunks = 0